<template>
  <div ref="chartContainer" class="chart-doughnut-container">
    <Doughnut ref="chart" :data="data" :options="options" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  components: {
    Doughnut
  },
  props: ['data', 'options'],
  data () {
    return {
      resizeObserver: null
    }
  },
  mounted () {
    const container = this.$refs.chartContainer
    if (!container || typeof ResizeObserver === 'undefined') {
      return
    }

    this.resizeObserver = new ResizeObserver(() => {
      const chartInstance = this.$refs.chart?.chart
      if (!chartInstance) {
        return
      }

      // Keep the canvas dimensions in sync when the container grows back.
      requestAnimationFrame(() => {
        chartInstance.resize()
      })
    })

    this.resizeObserver.observe(container)
  },
  beforeUnmount () {
    this.resizeObserver?.disconnect()
    this.resizeObserver = null
  }
}
</script>
<style scoped>
.chart-doughnut-container {
  width: 100%;
}

</style>
